import { TSS_ORANGE_2, TSS_ORANGE } from 'tss-core-lib-common';
import { StyleSheet } from 'aphrodite';

var styles = StyleSheet.create({
  validationErrorRow: {
    position: 'relative',
    backgroundColor: TSS_ORANGE_2(),

    '::after': {
      position: 'absolute',
      content: '""',
      backgroundColor: TSS_ORANGE(),
      top: 0,
      left: 0,
      bottom: 0,
      width: 4,
      zIndex: 2
    }
  },

  validationErrorMessage: {
    fontSize: '1.6rem',
    fontWeight: 500,
    margin: '1.2rem 0 1rem 0.2rem'
  }
});

export { styles };